import { render, staticRenderFns } from "./TreeItemCRUD.vue?vue&type=template&id=ac950982&scoped=true"
import script from "./TreeItemCRUD.vue?vue&type=script&lang=js"
export * from "./TreeItemCRUD.vue?vue&type=script&lang=js"
import style0 from "./TreeItemCRUD.vue?vue&type=style&index=0&id=ac950982&scoped=true&lang=scss"
import style1 from "./TreeItemCRUD.vue?vue&type=style&index=1&id=ac950982&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac950982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac950982')) {
      api.createRecord('ac950982', component.options)
    } else {
      api.reload('ac950982', component.options)
    }
    module.hot.accept("./TreeItemCRUD.vue?vue&type=template&id=ac950982&scoped=true", function () {
      api.rerender('ac950982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TreeItemCRUD.vue"
export default component.exports